<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { supplierService } from "../../../../services/inventoryservice/supplier.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Supplier List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      supplierData: {},
      typeData: {},
      fetchingStats: false,
      title: "Supplier List",

    };
  },
  mounted() {

    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      supplierService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.supplierData = response;
        });
    },

    deleted: function(id) {
      supplierService.remove(id)
        .then(response => {
        
          // this.supplierData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "supplier-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'supplier-add'}" :title="$t('supplier.text')" />
    <List v-bind:dataList="supplierData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ `code: ${$t('supplier.code')}`, `name: ${$t('supplier.name')}`, 
            `phone_no_1: ${$t('supplier.phone-no-1')}`, `phone_no_2: ${$t('supplier.phone-no-2')}`, `address: ${$t('supplier.address')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'supplier-edit'}"
          v-bind:filter="{
            search: ['suppliers.code', 'suppliers.name', 'suppliers.name_en', 'suppliers.phone_no_1', 'suppliers.phone_no_2'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>